import { useEffect, useState } from 'react';

// SSR-safe media-query hook. Used to fall back from desktop-only affordances
// (kanban boards, dense tables) to mobile layouts. Mirrors Tailwind breakpoints.
export function useMediaQuery(query: string): boolean {
  const [matches, setMatches] = useState(() =>
    typeof window !== 'undefined' ? window.matchMedia(query).matches : false,
  );

  useEffect(() => {
    const mql = window.matchMedia(query);
    const onChange = () => setMatches(mql.matches);
    onChange();
    mql.addEventListener('change', onChange);
    return () => mql.removeEventListener('change', onChange);
  }, [query]);

  return matches;
}

// `md` breakpoint — the app's desktop/mobile boundary (see AppShell/Sidebar).
export function useIsDesktop(): boolean {
  return useMediaQuery('(min-width: 768px)');
}
